// extracted by mini-css-extract-plugin
export default {"mCard":"VB-z","image":"WB-z","imageNoBackground":"XB-z","imageHasCategory":"YB-z","fullWidth":"ZB-z"};